// pages/FormViewerPage/services/formViewerService/pixelsFormPage.ts — Form page pixel configs
import type { Form } from '../../../../types';
import type { PlatformPixelConfig } from '../../types';
import { withOptimizationPixels } from './pixelOptimization';

export function getFormPagePixelConfigs(
    form: Form | null,
    globalTrackingSettings: any,
    settingsLoading: boolean,
    activePlatform: string | null
): { allConfigs: PlatformPixelConfig[]; metaConfig: { ids: string[]; eventName: string } } {
    if (!form) return { allConfigs: [], metaConfig: { ids: [], eventName: 'ViewContent' } };
    const allConfigs: PlatformPixelConfig[] = [];

    // Meta
    {
        let metaIds: string[] = [];
        let metaEvent = 'ViewContent';
        const formTracking = form.trackingSettings?.formPage?.meta;
        if (formTracking) {
            if (formTracking.eventName) metaEvent = formTracking.eventName;
            const formPixelIds = formTracking.pixelIds?.filter((id: string) => id?.trim());
            if (formPixelIds && formPixelIds.length > 0) metaIds = formPixelIds;
        }
        // TANPA fallback global: kosong = kosong. Yg jalan cuma pixel pilihan
        // form + pixel optimasi brand (ViewContent/AddToCart/InitiateCheckout).
        metaIds = withOptimizationPixels(metaIds, globalTrackingSettings?.meta?.pixels, (form as any)?.brandId);
        if (metaIds.length > 0) allConfigs.push({ platform: 'meta', pixelIds: metaIds, eventName: metaEvent });
    }

    // Google
    {
        let googleIds: string[] = [];
        let googleEvent = 'view_item';
        const trackingSettings = form.trackingSettings?.formPage;
        if (trackingSettings?.google?.pixelIds && trackingSettings.google.pixelIds.length > 0) {
            googleIds = trackingSettings.google.pixelIds.filter((id: string) => id?.trim());
            googleEvent = trackingSettings.google.eventName || 'view_item';
        }
        // TANPA fallback global: kosong = kosong. Yg jalan cuma pixel pilihan
        // form + pixel optimasi brand.
        googleIds = withOptimizationPixels(googleIds, globalTrackingSettings?.google?.pixels, (form as any)?.brandId);
        if (googleIds.length > 0) allConfigs.push({ platform: 'google', pixelIds: googleIds, eventName: googleEvent });
    }

    // TikTok
    {
        let tiktokIds: string[] = [];
        let tiktokEvent = 'ViewContent';
        const trackingSettings = form.trackingSettings?.formPage;
        if (trackingSettings?.tiktok?.pixelIds && trackingSettings.tiktok.pixelIds.length > 0) {
            tiktokIds = trackingSettings.tiktok.pixelIds.filter((id: string) => id?.trim());
            tiktokEvent = trackingSettings.tiktok.eventName || 'ViewContent';
        }
        // Pixel optimasi iklan brand form ini ikut menerima event TikTok.
        tiktokIds = withOptimizationPixels(tiktokIds, globalTrackingSettings?.tiktok?.pixels, (form as any)?.brandId);
        if (tiktokIds.length > 0) allConfigs.push({ platform: 'tiktok', pixelIds: tiktokIds, eventName: tiktokEvent });
    }

    // Snack
    {
        let snackIds: string[] = [];
        let snackEvent = 'VIEW_CONTENT';
        const trackingSettings = form.trackingSettings?.formPage;
        if (trackingSettings?.snack?.pixelIds && trackingSettings.snack.pixelIds.length > 0) {
            snackIds = trackingSettings.snack.pixelIds.filter((id: string) => id?.trim());
            snackEvent = trackingSettings.snack.eventName || 'VIEW_CONTENT';
        }
        // Pixel optimasi iklan brand form ini ikut menerima event Snack.
        snackIds = withOptimizationPixels(snackIds, globalTrackingSettings?.snack?.pixels, (form as any)?.brandId);
        if (snackIds.length > 0) allConfigs.push({ platform: 'snack', pixelIds: snackIds, eventName: snackEvent });
    }

    // OpenAI Ads
    {
        let ids = form.trackingSettings?.formPage?.openai?.pixelIds?.filter((id: string) => id?.trim()) || [];
        const eventName = form.trackingSettings?.formPage?.openai?.eventName || 'ViewContent';
        ids = withOptimizationPixels(ids, globalTrackingSettings?.openai?.pixels, (form as any)?.brandId);
        if (ids.length) allConfigs.push({ platform: 'openai', pixelIds: ids, eventName });
    }

    const metaConfig = allConfigs.find(c => c.platform === 'meta');
    return { allConfigs, metaConfig: { ids: metaConfig?.pixelIds || [], eventName: metaConfig?.eventName || 'ViewContent' } };
}
